<template>
	<div class="row gutter-sm">
		<div class="col-xs-12 col-sm-12">
			<q-alert color="info" icon="fal fa-users">
				{{ $t('online_users') }}: {{ onlineQuantity }}
			</q-alert>
		</div>

		<div class="col-xs-12 col-sm-4">
			<chat
				:id_webcast="id_webcast"
				type_chat="moderation"
				order="t"
				@click_chat="clickChat"
			/>
		</div>

		<div class="col-xs-12 col-sm-4">
			<chat :id_webcast="id_webcast" type_chat="public" order="t" @click_chat="clickChat" />
		</div>

		<div class="col-xs-12 col-sm-4">
			<chat
				:id_webcast="id_webcast"
				type_chat="disapprove"
				order="td"
				@click_chat="clickChat"
			/>
		</div>

		<div class="col-xs-12 col-sm-12">
			<q-input
				v-model="new_message"
				:float-label="$t('new_message')"
				@keydown.enter="sendMessage()"
			/>
		</div>

		<div class="col-12">
			<div class="row gutter-sm ">
				<div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
					<q-btn
						color="tertiary"
						class="full-width"
						:label="$t('back')"
						icon="far fa-chevron-left"
						@click="hideModal()"
					/>
				</div>

				<div class="col-xs-12 col-sm-3" :class="getOrder('save')">
					<q-btn
						color="secondary"
						class="full-width"
						:label="$t('send')"
						icon="far fa-comment-dots"
						@click="sendMessage()"
					/>
				</div>
			</div>
		</div>

		<q-dialog v-model="show_dialog">
			<span slot="title">{{ $t(getTitle()) }}</span>

			<span slot="body">
				{{ chat.m }}
			</span>

			<template slot="buttons" slot-scope="props">
				<q-btn color="tertiary" :label="$t('cancel')" @click="show_dialog = false" />
				<q-btn
					color="negative"
					:label="$t('disapprove')"
					v-if="type_chat === 'public' || type_chat === 'moderation'"
					@click="reproveChat()"
				/>
				<q-btn
					color="positive"
					:label="$t('approve')"
					v-if="type_chat === 'moderation' || type_chat === 'disapprove'"
					@click="approveChat()"
				/>
			</template>
		</q-dialog>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Chat from 'components/webcasts/Chat'
import { db } from 'plugins/vuefire'

export default {
	name: 'AdminPresentialWebcastChatModeration',

	props: ['id_webcast'],

	components: {
		chat: Chat,
	},

	data() {
		return {
			show_dialog: false,
			chat: {},
			type_chat: '',
			new_message: '',
			online_users: '',
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
		}),

		getHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			})
		},

		onlineQuantity() {
			return this.online_users.length
		},
	},

	methods: {
		clickChat(chat, type_chat) {
			this.chat = chat
			this.type_chat = type_chat
			this.show_dialog = true
		},

		getTitle() {
			if (this.type_chat === 'public') return 'disapprove'
			else if (this.type_chat === 'moderation') return 'approve_or_disapprove'
			else if (this.type_chat === 'disapprove') return 'approve'
		},

		reproveChat() {
			this.show_dialog = false

			let fd = new FormData()
			fd.append('message_id', this.chat.id)

			this.$axios
				.post(
					`/admin_webcasts/webcasts/${this.id_webcast}/disapprove_chat_message/`,
					fd,
					this.getHeader
				)
				.then((response) => {
					this.chat = {}
					this.type_chat = ''
				})
				.catch((e) => {
					console.log(e)
				})
		},

		approveChat() {
			this.show_dialog = false

			let fd = new FormData()
			fd.append('message_id', this.chat.id)

			this.$axios
				.post(
					`/admin_webcasts/webcasts/${this.id_webcast}/approve_chat_message/`,
					fd,
					this.getHeader
				)
				.then((response) => {
					this.chat = {}
					this.type_chat = ''
				})
				.catch((e) => {
					console.log(e)
				})
		},

		sendMessage() {
			if (this.new_message) {
				let message = this.new_message
				this.new_message = ''

				let fd = new FormData()
				fd.append('message', message)

				this.$axios
					.post(
						`/admin_webcasts/webcasts/${this.id_webcast}/send_chat_message/`,
						fd,
						this.getHeader
					)
					.then((response) => {})
					.catch((e) => {
						console.log(e)
					})
			}
		},

		getOrder(name) {
			if (name == 'cancel') {
				if (this.$q.platform.is.mobile) return 'order-last'
				else return 'order-first'
			} else if (name == 'save') {
				if (this.$q.platform.is.mobile) return 'order-first'
				else return 'order-last'
			}
		},

		hideModal() {
			this.$emit('hideModal', '')
		},
	},

	created() {
		this.$bind(
			'online_users',
			db
				.collection(`webcast_user_online`)
				.where('st', '==', 'on')
				.where('we', '==', parseInt(this.id_webcast))
		).then((online_users) => {
			this.online_users === online_users
		})
	},
}
</script>

<style></style>
